import React from 'react'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'

interface DetailProps {
  listAdjustment: any
}

export const UsefulLifeAdjustmentDetailContent = (props: DetailProps) => {
  const { listAdjustment } = props

  return (
    <>
      <div className="content-wrap full">
        <div className="desc " style={{ color: 'grey' }}>
          {`Document Description`}
        </div>
        <div className="mdDesc text-noflow">
          {listAdjustment?.UsefulAdjustment?.DocumentDesc}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc " style={{ color: 'grey' }}>
          {`Reason`}
        </div>
        <div className="mdDesc text-noflow">
          {listAdjustment?.UsefulAdjustment?.Reason}
        </div>
      </div>
    </>
  )
}
